module.exports = __webpack_public_path__ + "img/technical_support_01.f605e3b3.jpg";